module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "countrybox",
    attrs: {
      "id": 'territory' + _vm.id
    }
  }, [_c('div', {
    staticClass: "icon",
    attrs: {
      "id": 'icon' + _vm.id
    }
  }, [_c('icon', {
    attrs: {
      "code": _vm.icon,
      "size": 21
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "T-label",
    attrs: {
      "id": 'label' + _vm.id
    }
  }, [_vm._v("\n    " + _vm._s(_vm.reserves) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d33007f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/territory.vue
// module id = 201
// module chunks = 0